import { useMemo } from 'react';

import { useFetchEpisodeCategoriesQuery } from '@/store';
import { Episode, EpisodeCard, EpisodeCategory } from '@/types';

type EpisodeCategoryInstance = EpisodeCategory['libraryCategories'][number];

export const useEpisodeCategories = (episode: Episode | EpisodeCard) => {
  // TODO: Add a mechanism to pre-fetch multiple episode categories and pull from store if available
  const { data: categoryList } = useFetchEpisodeCategoriesQuery({
    episodeIds: [episode.episodeId],
  });

  const filteredCategoriesString = useMemo(() => {
    const categories =
      categoryList?.entities[episode.episodeId]?.libraryCategories;
    return categories
      ?.filter(
        category => category.name !== 'Ethics' && category.name !== 'Video',
      )
      ?.map(
        (category: unknown) =>
          (category as EpisodeCategoryInstance).subCategories
            ?.map(
              subCategory =>
                `${(category as EpisodeCategoryInstance).name}: ${subCategory.name}`,
            )
            .join(', ') ?? (category as EpisodeCategoryInstance).name,
      )
      ?.join(', ');
  }, [categoryList, episode.episodeId]);

  return filteredCategoriesString;
};
